import { render, staticRenderFns } from "./PageAdd.vue?vue&type=template&id=75ecb5ee&scoped=true&"
import script from "./PageAdd.vue?vue&type=script&lang=js&"
export * from "./PageAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageAdd.vue?vue&type=style&index=0&id=75ecb5ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ecb5ee",
  null
  
)

export default component.exports